import { ColPresetType } from '../redux/clientConfiguration/clientConfigurationSlice';

const deepEqual = (a: unknown, b: unknown): boolean => {
 if (a === b) return true;
 if (a === null || b === null || typeof a !== typeof b) return false;
 if (typeof a !== 'object') return a === b;

 if (Array.isArray(a) && Array.isArray(b)) {
  if (a.length !== b.length) return false;
  return a.every((item, i) => deepEqual(item, b[i]));
 }

 if (Array.isArray(a) !== Array.isArray(b)) return false;

 const aObj = a as Record<string, unknown>;
 const bObj = b as Record<string, unknown>;
 const aKeys = Object.keys(aObj);
 const bKeys = Object.keys(bObj);
 if (aKeys.length !== bKeys.length) return false;
 return aKeys.every((key) => key in bObj && deepEqual(aObj[key], bObj[key]));
};

const deepDiff = (
 saved: unknown,
 current: unknown,
 label?: string,
): Record<string, unknown> | null => {
 if (deepEqual(saved, current)) return null;

 if (
  saved === null ||
  saved === undefined ||
  current === null ||
  current === undefined
 ) {
  return { [label ?? '_']: { saved, current } };
 }

 if (typeof saved !== 'object' || typeof current !== 'object') {
  return { [label ?? '_']: { saved, current } };
 }

 if (Array.isArray(saved) && Array.isArray(current)) {
  const result: Record<string, unknown> = {};
  const maxLen = Math.max(saved.length, current.length);
  for (let i = 0; i < maxLen; i++) {
   const itemDiff = deepDiff(saved[i], current[i], String(i));
   if (itemDiff) Object.assign(result, itemDiff);
  }
  return Object.keys(result).length > 0 ? result : null;
 }

 const sObj = saved as Record<string, unknown>;
 const cObj = current as Record<string, unknown>;
 const allKeys = new Set([...Object.keys(sObj), ...Object.keys(cObj)]);
 const result: Record<string, unknown> = {};

 allKeys.forEach((key) => {
  const childDiff = deepDiff(sObj[key], cObj[key], key);
  if (childDiff) Object.assign(result, childDiff);
 });

 return Object.keys(result).length > 0 ? result : null;
};

export const isPresetChanged = (
 presets: ColPresetType[] | undefined | null,
 currentPreset: ColPresetType,
) => {
 const savedPreset = presets?.find((item) => item.name === currentPreset?.name);
 if (!savedPreset || savedPreset === currentPreset) {
  return false;
 }

 const diffs: Record<string, unknown> = {};

 const colDiff = deepDiff(savedPreset.columns, currentPreset.columns);
 if (colDiff) diffs.columns = colDiff;

 const filterDiff = deepDiff(savedPreset.filters, currentPreset.filters);
 if (filterDiff) diffs.filters = filterDiff;

 if ((savedPreset.isPro ?? false) !== (currentPreset.isPro ?? false)) {
  diffs.isPro = {
   saved: savedPreset.isPro ?? false,
   current: currentPreset.isPro ?? false,
  };
 }

 const limitDiff = deepDiff(savedPreset.limit, currentPreset.limit);
 if (limitDiff) diffs.limit = limitDiff;

 const hasChanges = Object.keys(diffs).length > 0;
 //  if (hasChanges) {
 //   console.log(`[Preset "${currentPreset.name}"] differences:`, diffs);
 //  }

 return hasChanges;
};

